import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

export const PaymentFooterPanel = styled(Stack, { label: 'PaymentFooter' })(({ theme }) => ({
  marginTop: 'auto',
  alignItems: 'center',
  flexDirection: 'row',
  backgroundColor: theme.palette.common.white,
  zIndex: theme.zIndex.appBar,
  boxShadow: theme.shadows[5],
  padding: theme.spacing(1.5, 3),
  justifyContent: 'end',
}));
